import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import { categories, getCategoryBySlug } from '@/mocks/categories';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-3">
              精选文章
            </h2>
            <p className="text-foreground-600 text-base">编辑精选的高质量技术文章，涵盖最热门的技术话题</p>
          </div>
          <Link
            to="/category/frontend"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {featured.slice(0, 2).map((article) => {
            const cat = getCategoryBySlug(article.category);
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden"
              >
                <div className="p-6 md:p-8">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                      {cat?.name || article.category}
                    </span>
                    <span className="text-xs text-foreground-500">{article.publishDate}</span>
                    <span className="text-xs text-foreground-500">{article.readTime} 分钟阅读</span>
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-5 line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex flex-wrap items-center gap-3 mb-5">
                    {article.tags.map((tag) => (
                      <span key={tag} className="px-2.5 py-1 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2.5">
                      <img
                        src={article.authorAvatar}
                        alt={article.author}
                        className="w-8 h-8 rounded-full object-cover"
                      />
                      <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">{article.author}</span>
                    </div>
                    <div className="flex items-center gap-4 text-xs text-foreground-500">
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-eye-line"></i> {article.viewCount.toLocaleString()}
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-heart-line"></i> {article.likeCount.toLocaleString()}
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-chat-3-line"></i> {article.commentCount}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-6 md:mt-8">
          {featured.slice(2).map((article) => {
            const cat = getCategoryBySlug(article.category);
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 p-5 md:p-6"
              >
                <div className="flex items-center gap-2.5 mb-3">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    {cat?.name || article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime} 分钟</span>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <img
                      src={article.authorAvatar}
                      alt={article.author}
                      className="w-6 h-6 rounded-full object-cover"
                    />
                    <span className="text-xs text-foreground-600 whitespace-nowrap">{article.author}</span>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="whitespace-nowrap">{article.viewCount.toLocaleString()} 阅读</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}